import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ModalNavPage} from "../modal-nav/modal-nav";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {Subscription} from "rxjs/Subscription";
import {AuditService} from "../../store/audit/audit.service";
import {AuditEntity} from "../../store/audit/audit.entity";
import {ProtocolService} from "../../store/protocol/protocol.service";

/**
 * Generated class for the ExistsAuditProtocolPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-exists-audit-protocol',
  templateUrl: 'exists-audit-protocol.html',
})
export class ExistsAuditProtocolPage implements OnInit, OnDestroy{

  public protokolle: Array<any> = [];

  private _customerId: string = null;
  private _pruefungSubscription: Subscription;

  constructor(private modalNavPage: ModalNavPage,
              public navCtrl: NavController,
              public navParams: NavParams,
              private loadingProvider: LoadingServiceProvider,
              private auditService: AuditService,
              private protocolService: ProtocolService
  ) {
    this._customerId = this.navParams.get('customerId');
  }

  ngOnInit(){
    this._pruefungSubscription = this.auditService.getAllByCustomerId(this._customerId)
      .map((audits: Array<AuditEntity>) => {
        let protocols = [];
        audits.forEach((audit: AuditEntity) => {
        audit.protokolle.forEach((protokolId: string) => {
          protocols.push({protokollId: protokolId, pruefungId: audit._id, erstellungsDatum: audit.erstellungsDatum, location: null});
          });
        });
        return protocols;
      })
      .mergeMap(protocols => this.protocolService.getByIds(protocols.map(protocol => protocol.protokollId)), (valueFromSource, valueFromInner) => {
        return {outer: valueFromSource, inner: valueFromInner}
      })
      .map((result) => {
        return result.outer.map((value) => {
          value.location = result.inner.find((innerValue) => {
            return innerValue._id === value.protokollId
          }).location || '- kein Standort -';
          return value;
        })
      })
      .subscribe((protocols) => {
        this.protokolle = protocols;
      });
  }

  ngOnDestroy(){
    this._pruefungSubscription.unsubscribe();
  }

  public openProtokoll(pruefung: any): void {
    this.loadingProvider.present();
    this.modalNavPage.dismissModal({pruefungId: pruefung.pruefungId, protokollId: pruefung.protokollId});
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExistsAuditProtocolPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/exists-audit-protocol/exists-audit-protocol.ts